module.exports = __webpack_public_path__ + "img/checkbox-on.3b2f6f67.svg";